// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__cz\\+t1 {
  overflow-x: hidden;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  left: 0;
  height: calc(100vh - 104px);
  overflow-y: scroll;
  width: 210px;
  background-color: var(--color-bg-sidebar);
  flex-grow: 1;
  padding-top: 75px;
}

.Sidebar_sidebar_header__5EZvS {
  padding-left: 25px;
}

.Sidebar_navbar__LUDoR {
  margin-top: 8px;
  color: var(--color-font-10);
}

.Sidebar_list_item_button__lOHta {
  background-color: var(--color-bg-sidebar-item) !important;
}

.Sidebar_list_item_button__lOHta:hover {
  background-color: var(--color-bg-sidebar-item-hover) !important;
}

.Sidebar_selected__uvH0v {
  background-color: var(--color-bg-sidebar-item-selected) !important;
}

.Sidebar_selected__uvH0v:hover {
  background-color: var(--color-bg-sidebar-item-selected) !important;
}

.Sidebar_row_container__IzgIk {
  width: 220px;
  display: flex;
  align-items: center;
}

.Sidebar_count__7FdMV {
  font-size: 15px;
  text-align: right;
  width: 30px;
  display: inline-block;
  font-weight: bold;
}

.Sidebar_cases_item__\\+CLhB {
  font-size: 12px;
  color: var(--color-font-10);
  height: 50px;
}

.Sidebar_cases_icon__NIwIs {
  height: 22px;
}

.Sidebar_cases_icon__NIwIs svg {
  font-size: 22px !important;
  margin-left: 7px;
  margin-right: 10px;
}

.Sidebar_cases_title__f4thU {
  width: 106px;
  font-size: 16px;
  display: inline-block;
  letter-spacing: 0.5px;
  font-weight: 700;
}

.Sidebar_status_item__pqtwj {
  height: 45px;
  font-size: 12px;
}

.Sidebar_status_icon__CWlyU {
  height: 19px;
}

.Sidebar_status_no_icon__ip6u6 {
  margin-left: 65px;
}

.Sidebar_status_icon__CWlyU svg {
  font-size: 20px !important;
  margin-left: 24px;
  margin-right: 11px;
}

.Sidebar_status_title__EHjEh {
  width: 90px;
  font-size: 13px;
  display: inline-block;
  height: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.Sidebar_status_title_non_clickable__EAyux {
  width: 90px;
  font-size: 13px;
  display: inline-block;
  height: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  cursor: default;
}

.Sidebar_settings_container__PaeR7 {
  padding-bottom: 150px;
}

.Sidebar_settings_nav__k7t4v {
  overflow: scroll;
}

.Sidebar_settings_icon__knHJg {
  font-size: 22px !important;
  margin-left: 7px;
  margin-right: 10px;
}

.Sidebar_email_flows_agent__feSXr {
  margin: 0px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Layout/Sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".sidebar {\n  overflow-x: hidden;\n  overflow-y: scroll;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: calc(100vh - 104px);\n  overflow-y: scroll;\n  width: 210px;\n  background-color: var(--color-bg-sidebar);\n  flex-grow: 1;\n  padding-top: 75px;\n}\n\n.sidebar_header {\n  padding-left: 25px;\n}\n\n.navbar {\n  margin-top: 8px;\n  color: var(--color-font-10);\n}\n\n.list_item_button {\n  background-color: var(--color-bg-sidebar-item) !important;\n}\n\n.list_item_button:hover {\n  background-color: var(--color-bg-sidebar-item-hover) !important;\n}\n\n.selected {\n  background-color: var(--color-bg-sidebar-item-selected) !important;\n}\n\n.selected:hover {\n  background-color: var(--color-bg-sidebar-item-selected) !important;\n}\n\n.row_container {\n  width: 220px;\n  display: flex;\n  align-items: center;\n}\n\n.count {\n  font-size: 15px;\n  text-align: right;\n  width: 30px;\n  display: inline-block;\n  font-weight: bold;\n}\n\n.cases_item {\n  font-size: 12px;\n  color: var(--color-font-10);\n  height: 50px;\n}\n\n.cases_icon {\n  height: 22px;\n}\n\n.cases_icon svg {\n  font-size: 22px !important;\n  margin-left: 7px;\n  margin-right: 10px;\n}\n\n.cases_title {\n  width: 106px;\n  font-size: 16px;\n  display: inline-block;\n  letter-spacing: 0.5px;\n  font-weight: 700;\n}\n\n.status_item {\n  height: 45px;\n  font-size: 12px;\n}\n\n.status_icon {\n  height: 19px;\n}\n\n.status_no_icon {\n  margin-left: 65px;\n}\n\n.status_icon svg {\n  font-size: 20px !important;\n  margin-left: 24px;\n  margin-right: 11px;\n}\n\n.status_title {\n  width: 90px;\n  font-size: 13px;\n  display: inline-block;\n  height: 18px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.status_title_non_clickable {\n  width: 90px;\n  font-size: 13px;\n  display: inline-block;\n  height: 18px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  cursor: default;\n}\n\n.settings_container {\n  padding-bottom: 150px;\n}\n\n.settings_nav {\n  overflow: scroll;\n}\n\n.settings_icon {\n  font-size: 22px !important;\n  margin-left: 7px;\n  margin-right: 10px;\n}\n\n.email_flows_agent {\n  margin: 0px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__cz+t1`,
	"sidebar_header": `Sidebar_sidebar_header__5EZvS`,
	"navbar": `Sidebar_navbar__LUDoR`,
	"list_item_button": `Sidebar_list_item_button__lOHta`,
	"selected": `Sidebar_selected__uvH0v`,
	"row_container": `Sidebar_row_container__IzgIk`,
	"count": `Sidebar_count__7FdMV`,
	"cases_item": `Sidebar_cases_item__+CLhB`,
	"cases_icon": `Sidebar_cases_icon__NIwIs`,
	"cases_title": `Sidebar_cases_title__f4thU`,
	"status_item": `Sidebar_status_item__pqtwj`,
	"status_icon": `Sidebar_status_icon__CWlyU`,
	"status_no_icon": `Sidebar_status_no_icon__ip6u6`,
	"status_title": `Sidebar_status_title__EHjEh`,
	"status_title_non_clickable": `Sidebar_status_title_non_clickable__EAyux`,
	"settings_container": `Sidebar_settings_container__PaeR7`,
	"settings_nav": `Sidebar_settings_nav__k7t4v`,
	"settings_icon": `Sidebar_settings_icon__knHJg`,
	"email_flows_agent": `Sidebar_email_flows_agent__feSXr`
};
export default ___CSS_LOADER_EXPORT___;
